// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__UzamG","Arrow":"Button_Arrow____xn6","Link":"Button_Link__5PGOY","TitleLastWord":"Button_TitleLastWord__cO5h7"};